import { useServiceFeatures } from 'hooks/useServiceContext';
import { Quoting } from 'types/enums/Integrations';

// Auto transport quoting is only offered when Super Dispatch is connected.
export function useHasSuperDispatchQuoting(): boolean {
  const { quotingIntegrations } = useServiceFeatures();

  return quotingIntegrations.some(
    (integration) => integration.name === Quoting.SuperDispatch
  );
}
